import { schema } from "@nodl/core";
import { z } from 'zod';
const DataTempSchema = schema( z.object({ columns: z.object({ name: z.string(), type: z.string() }).array().nullable() }));

export { DataTempSchema }
